<template>
  <div class="data-up">
    <div class="data-option-title">
      配置敏感词规则后，将会自动从留存的会话记录中监控敏感词，形成统计记录。监控范围包括所有对象直接的会话内容
      <el-button type="primary" @click="new_rules">新建规则</el-button>
    </div>
    <div class="release-list" v-loading="tableLoading">
      <div class="release-list-header">
        <div class="release-list-header-item item-width-content">规则名称</div>
        <div class="release-list-header-item item-width-time">敏感词数量</div>
        <div class="release-list-header-item item-width-auth">创建时间</div>
        <div class="release-list-header-item item-width-account">更新时间</div>
        <div class="release-list-header-item item-width-num">操作</div>
      </div>
      <div class="release-list-body">
        <div
          v-if="tableDataOverall.length === 0 && tableLoading === false"
          class="release-list-noData"
        >
          <img alt="" class="release-list-noData-img" :src="g_imgSrc.bgWhite" />
          <div class="release-list-noData-word">暂无相关内容</div>
        </div>
        <div
          :class="data.status === 0 ? 'release-list-item release-list-item-d' : 'release-list-item'"
          :key="data.id"
          v-for="data in tableDataOverall"
        >
          <div class="item-time item-width-content">
            <div class="item-time-inner">
              {{ data.name }}
            </div>
          </div>
          <div class="item-time item-width-time">
            <div class="item-time-inner">
              {{ data.total }}
            </div>
          </div>
          <div class="item-time item-width-auth">
            <div class="item-time-inner">
              {{ data.create_time }}
            </div>
          </div>
          <div class="item-time item-width-account">
            <div class="item-time-inner">
              {{ data.update_time }}
            </div>
          </div>
          <div class="item-time item-width-num">
            <div class="item-time-inner">
              <button
                @click="compile_rules(data)"
                :disabled="data.status === 0 ? 'disabled' : false"
                class="oprateButton"
                :class="data.status === 0 ? 'button_s' : ''"
              >
                编辑
              </button>
              <button
                @click="delete_rules(data)"
                :disabled="data.status === 0 ? 'disabled' : false"
                class="oprateButton"
                :class="data.status === 0 ? 'button_s' : ''"
              >
                删除
              </button>
            </div>
          </div>
        </div>
      </div>

      <el-dialog
        class="option-dialog"
        :title="rulesTitle"
        :visible.sync="dialogVisible"
        width="560px"
      >
        <div class="input-rule-wrap">
          <div class="input-rule-label">规则名称</div>
          <div class="input-rule-name">
            <el-input
              class="input-rule"
              type="text"
              placeholder="请输入规则名称"
              v-model="text"
              :maxlength="10"
            ></el-input>
            <span>{{ text.length }}/10</span>
          </div>
          <div class="input-rule-label">敏感词</div>
          <div class="input-rule-list">
            <span class="item" v-for="(item, index) in textRuleList" :key="index">
              {{ item }}
              <i @click="delItem(index)">×</i>
            </span>
            <el-input
              class="input-keyword"
              type="text"
              :placeholder="
                rulesTitle === '编辑规则' && textRuleList.length !== 0
                  ? ''
                  : '请输入敏感词，以回车键隔开'
              "
              v-model.trim="textRule"
              @keyup.enter.native="submit()"
            ></el-input>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="sensitive_affirm">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <el-pagination
      class="pagination"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="handleSizeChange"
      :total="total"
      :page-sizes="g_pageSizesConfig"
      :page-size="size"
      :current-page="currentPage"
      @current-change="handleCurrentChange"
    ></el-pagination>
  </div>
</template>
<script>
import { dateFormat } from '@/utils/time';
import {
  EyaoSaaSQuerySensitiveWords,
  EyaoSaaSCreateSensitiveWords,
  EyaoSaaSModifySensitiveWords,
  EyaoSaaSDeleteSensitiveWords,
} from '@/api/enterpriseWeChatManagement';
export default {
  data() {
    return {
      text: '', // 弹窗输入规则名
      tableDataOverall: [], // 表格整体数据数据
      total: 1, // 总页数
      currentPage: 1, // 页数
      size: 10, // 每页数量
      tableLoading: false, // tableLoading框
      dialogVisible: false, // 规则弹窗显示
      textRule: '', // 敏感词输入
      textRuleList: [], // 敏感词输入列表
      rulesTitle: '', // 敏感词弹窗标题
      rules_id: null, // 列表id
    };
  },
  mounted() {
    this.size = this.g_pageSizeDefault;
    this.QuerySensitiveWords();
  },
  methods: {
    // 新建规则
    new_rules() {
      this.textRuleList.length = 0;
      this.text = '';
      this.textRule = '';
      this.dialogVisible = true;
      this.rulesTitle = '新建规则';
    },
    // 编辑规则
    compile_rules(data) {
      this.dialogVisible = true;
      this.rulesTitle = '编辑规则';
      this.textRuleList = data.words;
      this.text = data.name;
      this.rules_id = data.id;
    },
    // 删除敏感词列表
    delete_rules(data) {
      const { id } = data;
      this.$confirm('是否确定删除该敏感词配置？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.EyaoSaaSDeleteSensitiveWords(id);
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    // 敏感词配置列表
    async QuerySensitiveWords() {
      this.tableLoading = true;
      const today = new Date();
      const targetdayMilliseconds = today.getTime() + 1000 * 60 * 60 * 24 * 7;
      today.setTime(targetdayMilliseconds);
      const startTime = dateFormat(new Date(), 'YYYY-MM-dd HH:mm:SS');
      const endTime = dateFormat(today, 'YYYY-MM-dd HH:mm:SS');
      const createTime = [startTime, endTime];
      const req = Object.assign({
        create_time: createTime,
        limit: this.size,
        page: this.currentPage,
      });
      EyaoSaaSQuerySensitiveWords(req)
        .then((res) => {
          if (res) {
            this.tableDataOverall = res.list;
            this.total = Number(res.total);
            this.tableLoading = false;
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    // 创建敏感词
    async CreateSensitiveWords() {
      if (!this.text.trim()) {
        this.$message('请输入规则名称');
        return false;
      }
      if (this.textRuleList.length === 0) {
        this.$message('请输入敏感词');
        return false;
      }
      const req = Object.assign({
        id: 0,
        name: this.text,
        words: this.textRuleList,
      });
      EyaoSaaSCreateSensitiveWords(req)
        .then((res) => {
          if (res) {
            this.dialogVisible = false;
            this.QuerySensitiveWords();
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    // 修改敏感词
    async EyaoSaaSModifySensitiveWords() {
      const req = Object.assign({
        id: this.rules_id,
        name: this.text,
        words: this.textRuleList,
      });
      EyaoSaaSModifySensitiveWords(req)
        .then((res) => {
          if (res) {
            this.dialogVisible = false;
            this.QuerySensitiveWords();
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    // 删除敏感词
    async EyaoSaaSDeleteSensitiveWords(id) {
      const req = Object.assign({
        id,
      });
      EyaoSaaSDeleteSensitiveWords(req)
        .then((res) => {
          if (res) {
            this.$message({
              type: 'success',
              message: '删除成功!',
            });
            this.QuerySensitiveWords();
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    // 规则编辑确认事件
    sensitive_affirm() {
      const { rulesTitle } = this;
      if (rulesTitle === '新建规则') {
        this.CreateSensitiveWords();
      } else {
        this.EyaoSaaSModifySensitiveWords();
      }
    },
    // 敏感词选择删除
    delItem(index) {
      this.textRuleList.splice(index, 1);
    },
    // 敏感词输入
    submit() {
      if (this.textRule.trim() === '') {
        return false;
      }
      if (this.textRuleList.filter((item) => item === this.textRule.trim()).length > 0) {
        this.$message('请不要输入相同的敏感词');
        return false;
      }
      this.textRuleList.push(this.textRule.trim());
      this.textRule = '';
    },
    // 选择页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.QuerySensitiveWords();
    },
    handleSizeChange(val) {
      this.currentPage = 1;
      this.size = val;
      this.QuerySensitiveWords();
    },
    // 时间转时间戳
    timeToNumber(time) {
      const date = new Date(time.replace(/-/g, '/'));
      const result = date.getTime();
      return result;
    },
  },
};
</script>
<style scoped lang="scss">
.data-up {
  .data-option-title {
    display: flex;
    height: 59px;
    margin-bottom: 16px;
    overflow: hidden;
    font-size: 16px;
    color: #313233;
    justify-content: space-between;
    align-items: flex-end;
    .el-form {
      min-width: 1200px;
    }
    .el-button--primary {
      width: 128px;
      height: 48px;
      cursor: pointer;
      background: #2f96ff;
      border-radius: 8px;
    }
    .el-button--primary:hover {
      color: #fff;
      background: #63b0ff;
    }

    .data-Export:hover {
      background: rgba(0, 0, 0, 0.04);
    }

    .release-select {
      height: 48px;
      border-radius: 8px;
    }
  }
  .data-el-table {
    margin-top: 16px;
    border: 1px solid rgba(0, 0, 0, 0.08);
  }
}
.data-Export {
  position: relative;
  float: right;
  width: 128px;
  height: 48px;
  text-align: center;
  cursor: pointer;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  .data-Export-img {
    position: absolute;
    top: 11px;
    right: 87px;
    width: 26px;
    height: 26px;
  }
  .Export {
    position: absolute;
    top: 14px;
    right: 15px;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0;
    color: #606266;
    text-align: center;
  }
}
.pagination {
  float: right;
  margin-top: 12px;
  background: #fff;
}
.release-list {
  position: relative;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  .release-list-header {
    display: flex;
    width: 100%;
    height: 48px;
    font-size: 16px;
    background: rgba(216, 216, 216, 0.1);
    .release-list-header-item {
      display: inline-block;
      height: 100%;
      padding-left: 24px;
      margin-right: 8px;
      line-height: 48px;
      letter-spacing: 0;
      color: #303133;
    }
  }
}
.release-list-body {
  width: 100%;
  .release-list-noData {
    width: 100%;
    height: 100%;
    text-align: center;
    .release-list-noData-img {
      width: 240px;
      height: 192px;
      margin-top: 100px;
    }
    .release-list-noData-word {
      height: 22px;
      margin-top: 16px;
      margin-bottom: 140px;
      font-size: 16px;
      color: #909399;
      text-align: center;
    }
  }
  .release-list-item {
    display: flex;
    height: 56px;
    color: #606266;
    border-bottom: 1px solid rgba(0, 0, 0, 0.07);
  }
  .release-list-item-d {
    background: #eee;
  }
  .release-list-item:nth-child(1) {
    display: flex;
    height: 56px;
    margin-top: 8px;
    color: #606266;
    border-bottom: 1px solid rgba(0, 0, 0, 0.07);
  }
  .release-list-item:nth-child(30n) {
    display: flex;
    height: 56px;
    margin-bottom: 8px;
    color: #606266;
    border-bottom: none;
  }
  .item-time {
    position: relative;
    display: table;
    height: 56px;
    padding-left: 24px;
    margin-right: 8px;
  }
}
.item-time-inner {
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  button {
    padding: 5px;
    font-size: 16px;
    color: #2f96ff;
    cursor: pointer;
    background: none;
    border: none;
  }
  .button_s {
    padding: 5px;
    font-size: 16px;
    color: #909399;
    cursor: not-allowed;
    background: none;
    border: none;
  }
}
.item-width-content {
  width: 20%;
  min-width: 48px;
}
.item-width-time {
  width: 20%;
  min-width: 48px;
}
.item-width-auth {
  width: 20%;
  min-width: 48px;
}
.item-width-account {
  width: 20%;
  min-width: 48px;
}
.item-width-num {
  width: 20%;
  min-width: 48px;
  span {
    color: #2f96ff;
  }
}
.item-width-activeone {
  width: 13%;
  min-width: 48px;
}
.item-width-Reading {
  width: 11%;
  min-width: 60px;
}
.item-width-Forward {
  width: 13%;
  min-width: 48px;
}
.item-width-Collect {
  width: 9.5%;
  min-width: 48px;
}
.item-width-title {
  width: 10%;
  min-width: 48px;
}

.el-date-editor--daterange.el-input__inner,
.el-date-editor--timerange.el-input,
.el-date-editor--timerange.el-input__inner {
  width: 320px;
}

.input-rule-wrap {
  width: 320px;
  margin: 0 auto;

  .input-rule-label {
    margin-bottom: 8px;
    font-size: 16px;
    color: #303133;
  }
  .input-rule-name {
    position: relative;
    margin-bottom: 26px;
    span {
      position: absolute;
      top: 13px;
      right: 7px;
    }
  }
}
.input-rule-list {
  padding: 0 10px;
  overflow: hidden;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  .item {
    display: inline-block;
    padding: 6px 10px;
    margin: 6px 10px 0 0;
    font-size: 12px;
    color: #606266;
    background: #f0f2f5;
    border-radius: 3px;
    i {
      display: inline-block;
      width: 12px;
      height: 12px;
      margin-left: 8px;
      font-size: 12px;
      color: #fff;
      text-align: center;
      cursor: pointer;
      background: #c0c4cc;
      border-radius: 50%;
    }
  }
  .input-keyword {
    width: 100%;
    box-sizing: border-box;
  }
}
::v-deep {
  .release-label .el-form-item__label {
    font-size: 16px;
    color: #303133;
  }
  .release-select .el-input__inner {
    padding-top: 1px;
  }
  .el-dialog__header {
    padding: 20px 20px 10px;
  }
  .el-dialog__footer {
    text-align: center;
  }
  .pagination .number {
    color: #606266;
  }
  .pagination .active {
    color: #2f96ff !important;
  }
  .release-label.el-form-item__label {
    height: 48px;
    line-height: 48px;
    color: #303133;
    text-align: left;
  }
  .release-list .path {
    stroke: #2f96ff;
  }
  .pagination .el-input__inner {
    // width: 46px;
    height: 24px;
    border: 1px solid #dcdfe6;
    border-radius: 3px;
  }
  .release-label .el-date-editor--daterange.el-input,
  .el-input__inner {
    width: 100%;
    padding: 0;
    border: none;
  }
  .input-rule {
    width: 100%;
    .el-input__inner {
      width: 100%;
      padding-right: 40px !important;
      padding-left: 12px;
      border: 1px solid rgba(0, 0, 0, 0.08);
      box-sizing: border-box;
    }
  }
}
</style>
